export const typography = {
  type: {
    primary: '"Open Sans", sans-serif',
  },
  weight: {
    regular: '400',
    semibold: '600',
    bold: '700',
  },
  size: {
    s1: '12',
    s2: '14',
    s3: '16',
    m1: '20',
    m2: '24',
    m3: '28',
    l1: '32',
    l2: '40',
    l3: '48',
    code: '90',
  },
};
